import React from 'react'
import { Tooltip } from '~components/Tooltip'
import { Icon, IconName } from '~components/Icon'
import { Button, Container, Inner, Input } from './Stepper.styles'
import type { InputProps } from './Stepper.types'

const Stepper: React.FC<InputProps> = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { size = 'medium', value = 0, min = 0, max = Number.MAX_SAFE_INTEGER, onChange, isDisabled, ...otherProps } = props

  const formatValue = (valueToFormat: string | number): number => {
    const valueToNumber = Math.floor(parseInt(String(valueToFormat), 10))

    return !Number.isNaN(valueToNumber) ? Math.min(Math.max(valueToNumber, min), max) : min
  }

  const onChangeHandler = (changedValue: string) => {
    onChange && onChange(formatValue(changedValue))
  }

  const onClickHandler = (increment: number) => {
    onChange && onChange(formatValue(value + increment))
  }

  const isMinusDisabled = isDisabled || value <= min
  const isPlusDisabled = isDisabled || value >= max

  return (
    <Container>
      <Inner size={size}>
        <Tooltip content="Decrease" offset={-4}>
          <Button onClick={() => onClickHandler(-1)} disabled={isMinusDisabled} size={size} variant="transparent" shape="circle">
            <Icon name={IconName.minus} />
          </Button>
        </Tooltip>

        <Input
          size={size}
          value={value}
          onValueChange={onChangeHandler}
          disabled={isDisabled}
          inputMode="decimal"
          pattern="[0-9]*"
          ref={ref}
          {...otherProps}
        />

        <Tooltip content="Increase" offset={-4}>
          <Button onClick={() => onClickHandler(1)} disabled={isPlusDisabled} size={size} variant="transparent" shape="circle">
            <Icon name={IconName.plus} />
          </Button>
        </Tooltip>
      </Inner>
    </Container>
  )
})

Stepper.displayName = 'Stepper'

export default Stepper
